import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  TextField,
  Grid,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import {
  Close,
  Save,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AddSubscription: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    subscriptionName: '#0987654',
    category: '',
    subscriptionType: '',
    frequency: '',
    price: '',
    validityPeriod: '',
    status: '',
    description: '',
  });

  const handleInputChange = (field: string) => (event: any) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Subscription data:', formData);
    navigate('/subscriptions');
  };

  return (
    <Dialog
      open={true}
      onClose={() => navigate('/subscriptions')}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 }
      }}
    >
      <DialogTitle sx={{ 
        backgroundColor: 'primary.main', 
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Add Subscription
        </Typography>
        <IconButton
          onClick={() => navigate('/subscriptions')}
          sx={{ color: 'white' }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label="Subscription Name"
                value={formData.subscriptionName}
                onChange={handleInputChange('subscriptionName')}
                required
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth required>
                <InputLabel>Category</InputLabel>
                <Select
                  value={formData.category}
                  label="Category"
                  onChange={handleInputChange('category')}
                >
                  <MenuItem value="newspaper">Newspaper</MenuItem>
                  <MenuItem value="magazine">Magazine</MenuItem>
                  <MenuItem value="digital">Digital</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth required>
                <InputLabel>Subscription Type</InputLabel>
                <Select
                  value={formData.subscriptionType}
                  label="Subscription Type"
                  onChange={handleInputChange('subscriptionType')}
                >
                  <MenuItem value="ad-subscription">AD Subscription</MenuItem>
                  <MenuItem value="other-subscription">Other Subscription</MenuItem>
                  <MenuItem value="premium">Premium</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth required>
                <InputLabel>Frequency</InputLabel>
                <Select
                  value={formData.frequency}
                  label="Frequency"
                  onChange={handleInputChange('frequency')}
                >
                  <MenuItem value="daily">Daily</MenuItem>
                  <MenuItem value="weekly">Weekly</MenuItem>
                  <MenuItem value="monthly">Monthly</MenuItem>
                  <MenuItem value="yearly">Yearly</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label="Price"
                placeholder="Enter"
                type="number"
                value={formData.price}
                onChange={handleInputChange('price')}
                required
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label="Validity Period"
                placeholder="Enter"
                type="number"
                value={formData.validityPeriod}
                onChange={handleInputChange('validityPeriod')}
                required
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth required>
                <InputLabel>Status</InputLabel>
                <Select
                  value={formData.status}
                  label="Status"
                  onChange={handleInputChange('status')}
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label="Description (optional)"
                placeholder="Enter"
                multiline
                rows={3}
                value={formData.description}
                onChange={handleInputChange('description')}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button
          onClick={() => navigate('/subscriptions')}
          sx={{ px: 3 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          startIcon={<Save />}
          sx={{ px: 3 }}
        >
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSubscription;



